import React from 'react';
import DesktopSearch from './Search/DesktopSearch';
import { IMAGE_URL } from '../constants/SiteVariables';

const backgrounds = [
  'f_auto,w_1440,c_limit,q_50,e_blur:145/v1492612529/hero/hero_farm_1.jpg',
  'f_auto,w_1440,c_limit,q_50,e_blur:145/v1492612529/hero/hero_farm_2.jpg',
  'f_auto,w_1440,c_limit,q_50,e_blur:145/v1492612529/hero/hero_farm_3.jpg'
].map(i => IMAGE_URL + i);

const backgroundImage = backgrounds[Math.floor(Math.random() * backgrounds.length)];

export default class Jumbotron extends React.Component {
  render() {
    let styles = {
      backgroundImage: 'url(' + backgroundImage + ')',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    };

    return (<div className="search-hero" style={styles}>
      <div className='purple-overlay'>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-12">

            <div className='hero-content'>
              <div className='row'>
                <div className='col-md-10'>
                  <h1>Claim Your Business Listing</h1>
                  <div className='underline'></div>

                  <p>
                    We're locals and we're all about <strong>connecting people</strong>
                    – <strong>farmers</strong>, <strong>independent chefs</strong>,
                    and <strong>foodies</strong>. From a Friday date to getting
                    off the plane in a new city, <strong>everyone should have
                    easy access to the best in local food.</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className='search-container'>
              <DesktopSearch {...this.props} />
            </div>

            <div className='hero-footer'>
              <div className='row'>
                <div className='col-md-12'>
                  <p>
                    Questions? <strong> Contact the localvore Crew. We're here for you: <a href="mailto:help@localvore.co">help@localvore.co</a></strong>
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/Jumbotron.js